import UtilsService from "app/services/utils/utils.service";
import AdminService from "external-services/diary-admin-service/admin.service";
import PhoneNumberService from "app/services/phoneNumber/phoneNumber.service";

const NS = 'PhoneVaild'; // jshint ignore:line

export default function PhoneVaild() { // as phoneVaild
    "ngInject";

    return {
        require: 'ngModel',
        link,
        restrict: 'A'
    };

    function link(scope, element, attrs, ngModel) {

        if (!window.config.phoneValidation) {
            ngModel.$setValidity('phone-vaild', true);
        } else {
            var validate = function(viewValue) {
                var venue = AdminService.getVenue();


                // if (!ngModel.$modelValue || !ngModel.$viewValue) {
                if (!ngModel.$viewValue) {
                    // It's valid because we have nothing to compare against
                    ngModel.$setValidity('phone-vaild', true);
                } else {
                    var phoneNumber = ngModel.$viewValue;
                    phoneNumber = UtilsService.checkPhoneState(phoneNumber, venue.country, venue.state, true);
                    phoneNumber = PhoneNumberService.formatNumber(phoneNumber, venue.country, true);
                    ngModel.$setValidity('phone-vaild', !!phoneNumber);
                    if (phoneNumber) {
                        ngModel.$setViewValue(phoneNumber);
                        ngModel.$render();
                    }
                }

                return viewValue;
            };

            ngModel.$parsers.unshift(validate);
            ngModel.$formatters.push(validate);

            attrs.$observe('phoneVaild', function() {
                // Whenever the comparison model changes we'll re-validate
                return validate(ngModel.$viewValue);
            });
        }
    }

}
